export const IMGUR_CLIENT_ID = '9db53e5936cd02f';